export const AI_AREA_SECTIONS = [
  {
    id: "upload-documents",
    slug: "upload-documents",
    title: "Upload Documents",
    description:
      "Upload a PDF so the AI can read it. We'll break it into smaller pieces and keep it ready to use later.",
    actionLabel: "Open",
    icon: "upload",
  },
];

export const getSectionFromPath = (pathname) => {
  const match = pathname.match(/\/ai-area\/([^/]+)/);
  if (!match) {
    return null;
  }

  const slug = decodeURIComponent(match[1]).toLowerCase();
  return AI_AREA_SECTIONS.find((section) => section.slug === slug) || null;
};
